import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { SistemaMenuService } from './services/sistemaMenu.service';
import { BehaviorSubject, filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  standalone: true,
  selector: 'app-menus',
  imports: [CommonModule, RouterModule, MatIconModule, MatExpansionModule],
  templateUrl: './menus.component.html',
  styleUrl: './menus.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class MenusComponent {
  menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  routeActive: boolean = false;
  @Input() MenuExpandido: boolean = false;
  @Output() fecharMenu = new EventEmitter<boolean>();
  @Output() menuSelecionado = new EventEmitter<any>();
  constructor(
    private sistemaMenuService: SistemaMenuService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.atualizarMenu();
      });

    // E chama uma vez no início também:
    this.atualizarMenu();

  }
  fecharMenuFunc() {
    this.fecharMenu.emit(true);
  }

  expandirSomente(itemSelecionado: any) {
    const novaLista = this.menuList$.getValue().map(item => ({
      ...item,
      expanded: item.title === itemSelecionado.title
    }));

    this.menuList$.next(novaLista);
    this.fecharMenuFunc();
    this.cdr.detectChanges(); // pode até remover se não necessário
  }


  private atualizarMenu() {
    const listaAtual = this.menuList$.getValue();

    this.sistemaMenuService.getMenus().subscribe((data) => {
      const updated = data.map((item: any) => {
        const anterior = listaAtual.find(i => i.title === item.title);

        const submenuOrdenado = Array.isArray(item.submenu)
          ? [...item.submenu].sort((a: any, b: any) => (a?.ordem ?? Number.MAX_SAFE_INTEGER) - (b?.ordem ?? Number.MAX_SAFE_INTEGER))
          : item.submenu;

        return {
          ...item,
          submenu: submenuOrdenado,
          expanded: anterior?.expanded || false
        };
      }).sort((a: any, b: any) => (a?.ordem ?? Number.MAX_SAFE_INTEGER) - (b?.ordem ?? Number.MAX_SAFE_INTEGER));

      // Atalhos (item raiz com rota e sem submenu, ex.: Resumo) ficam no topo; a ordem do restante não muda.
      this.menuList$.next([...updated.filter((i: any) => this.ehAtalho(i)), ...updated.filter((i: any) => !this.ehAtalho(i))]);
    });
  }

  /** Item raiz que navega direto (tem rota e não tem submenu), em vez de abrir uma lista. */
  ehAtalho(item: any): boolean {
    return !!item?.page && !item?.submenu?.length;
  }

  menuSelecionadoFunc(item : any) {
    this.expandirSomente(item);
    this.menuSelecionado.emit(true);
  }

}